import { fetchLogoBase64, fecharComEsc, aguardarImagens, valorPorExtenso } from './impressaoVenda';

// Textos sugeridos ao ligar a Proposta Comercial em Parâmetros → Vendas.
// Cada linha das cláusulas vira um item com "–" na impressão.
export const PROPOSTA_PADRAO = {
  texto_introducao: 'Muito obrigado por solicitar os nossos serviços, para os quais submetemos à sua apreciação nossa proposta comercial abaixo:',
  texto_responsabilidades: 'Caso a sua empresa faça a retenção de impostos na fonte, favor nos informar no ato da autorização dos serviços, bem como nos enviar o comprovante de pagamento dos mesmos após a liquidação da Nota Fiscal.',
  texto_garantia: [
    'Nossos serviços têm garantia contada a partir da data de entrega do equipamento.',
    'Esta garantia cobre somente as falhas ocorridas no processo de reparo de nossa responsabilidade.',
    'A garantia não inclui despesas com locomoção, hospedagem e alimentação de nossos técnicos.',
    'Custos de transporte dos equipamentos até nossa oficina não são cobertos pela garantia.',
    'A garantia depende de: transporte, armazenamento e manuseio adequados; instalação correta, em condições ambientais especificadas e sem agentes agressivos; operação dentro dos limites de capacidade; manutenções preventivas periódicas; reparos ou modificações apenas por pessoal autorizado por escrito por nossa empresa.',
  ].join('\n'),
  texto_obs_final: [
    'Outros serviços/peças não citados neste escopo e que porventura sejam necessários serão negociados à parte.',
    'Os equipamentos não retirados após 90 dias da sua execução serão colocados à venda para cobrir as despesas com o conserto.',
  ].join('\n'),
  garantia_meses: '3',
  validade_dias: '15',
  impostos: 'Inclusos',
  local_servico: '',
};

const FRETE_LABEL = {
  '0': 'CIF (por conta do emitente)',
  '1': 'FOB (por conta do destinatário)',
  '2': 'Por conta de terceiros',
  '3': 'Próprio, por conta do remetente',
  '4': 'Próprio, por conta do destinatário',
  '9': 'Sem frete',
};

const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho',
  'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

const esc = v => String(v ?? '')
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
const brl = v => (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const qtd = v => (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
const dataBR = s => (s ? String(s).slice(0, 10).split('-').reverse().join('/') : '');
const ehServico = t => String(t || '').trim().toLowerCase() === 'serviço';
const fmtCnpjCpf = d => {
  const n = String(d || '').replace(/\D/g, '');
  if (n.length === 14) return n.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  if (n.length === 11) return n.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  return d || '';
};
const dataExtenso = s => {
  const [a, m, d] = String(s || '').slice(0, 10).split('-').map(Number);
  if (!a) return '';
  return `${d} de ${MESES[m - 1]} de ${a}`;
};
const diasEntre = (de, ate) => {
  if (!de || !ate) return null;
  const ms = new Date(String(ate).slice(0, 10) + 'T12:00:00') - new Date(String(de).slice(0, 10) + 'T12:00:00');
  return Math.round(ms / 86400000);
};
const linhasClausula = texto => String(texto || '').split('\n').map(l => l.trim()).filter(Boolean)
  .map(l => `<li>${esc(l.replace(/^[-–•*]\s*/, ''))}</li>`).join('');

export function montarHtmlProposta({ pedido, itens, cliente, vendedor, org, mostrar_icms }, imagens) {
  const cfg = { ...PROPOSTA_PADRAO, ...(org.proposta_config || {}) };
  const pr = pedido.proposta || {};
  const nomeEmpresa = org.nome_fantasia || org.razao_social || '';
  const numero = pedido.id;

  // ── Cabeçalho ──
  const cabecalho = imagens.cabecalho
    ? `<img class="banner" src="${imagens.cabecalho}">`
    : `<div class="cab-padrao">
        ${imagens.logo ? `<img src="${imagens.logo}" class="logo">` : ''}
        <div class="cab-empresa">
          <div class="cab-nome">${esc(org.razao_social || nomeEmpresa)}</div>
          ${org.cnpj ? `<div>CNPJ: ${esc(fmtCnpjCpf(org.cnpj))}${org.ie ? ` &nbsp; IE: ${esc(org.ie)}` : ''}</div>` : ''}
          <div>${esc([org.logradouro, org.numero, org.bairro].filter(Boolean).join(', '))}</div>
          <div>${esc([org.cidade, org.uf].filter(Boolean).join('/'))}${org.telefone ? ` &nbsp;·&nbsp; ${esc(org.telefone)}` : ''}</div>
        </div>
      </div>`;
  const rodape = imagens.rodape
    ? `<img class="banner" src="${imagens.rodape}">`
    : `<div class="rod-padrao">
        <b>${esc(org.razao_social || nomeEmpresa)}</b>
        ${esc([[org.logradouro, org.numero].filter(Boolean).join(', '), org.bairro, [org.cidade, org.uf].filter(Boolean).join('/'), org.cep ? `CEP ${org.cep}` : ''].filter(Boolean).join(' – '))}<br>
        ${esc([org.telefone, org.email, org.site, org.cnpj ? `CNPJ: ${fmtCnpjCpf(org.cnpj)}` : ''].filter(Boolean).join('  |  '))}
      </div>`;

  // ── Destinatário ──
  const fones = cliente ? [cliente.fone1, cliente.fone2, cliente.fone3].filter(Boolean).join(' / ') : (pedido.cliente_telefone_avulso || '');
  const nomeCliente = cliente?.nome || pedido.cliente_nome || pedido.cliente_nome_avulso || '';
  const endCliente = cliente ? [
    [cliente.logradouro, cliente.numero, cliente.complemento].filter(Boolean).join(', '),
    cliente.bairro, [cliente.cidade, cliente.estado].filter(Boolean).join('/'),
  ].filter(Boolean).join(' – ') : '';

  // ── Equipamento ──
  const temEquip = ['equip_marca', 'equip_carcaca', 'equip_serie', 'equip_tag', 'equip_tensao', 'equip_frequencia', 'equip_fabricacao']
    .some(k => pr[k]);
  const temNfEntrada = pr.nf_entrada_numero || pr.nf_entrada_data;
  const blocoEquip = (pr.equip_tipo || temEquip || temNfEntrada) ? `
    <div class="equip-titulo">Equipamento: <b>${esc(pr.equip_tipo || '')}</b></div>
    ${temEquip ? `<table class="grade equip">
      <tr><th>Marca</th><th>Carcaça / Modelo</th><th>Nº de Série</th><th>Tag</th><th>Tensão</th><th>Frequência</th><th>Dt. Fabricação</th></tr>
      <tr><td>${esc(pr.equip_marca)}</td><td>${esc(pr.equip_carcaca)}</td><td>${esc(pr.equip_serie)}</td><td>${esc(pr.equip_tag)}</td>
          <td>${esc(pr.equip_tensao)}</td><td>${esc(pr.equip_frequencia)}</td><td>${esc(dataBR(pr.equip_fabricacao) || pr.equip_fabricacao)}</td></tr>
    </table>` : ''}
    ${temNfEntrada ? `<table class="grade nfent"><tr>
      <th>Nota de Entrada</th><td>${esc(pr.nf_entrada_numero)}</td>
      <th>Série</th><td>${esc(pr.nf_entrada_serie)}</td>
      <th>Data</th><td>${esc(dataBR(pr.nf_entrada_data))}</td></tr></table>` : ''}` : '';

  // ── Itens: serviços primeiro, depois peças ──
  const servicos = itens.filter(i => ehServico(i.tipo_item));
  const pecas = itens.filter(i => !ehServico(i.tipo_item));
  const nCols = mostrar_icms ? 8 : 7;
  let seq = 0;
  const linhaItem = i => {
    seq += 1;
    const q = parseFloat(i.quantidade) || 0;
    const unit = q ? (parseFloat(i.subtotal) || 0) / q : 0;
    return `<tr>
      <td class="c">${seq}</td><td class="r">${qtd(q)}</td><td class="c">${esc(i.unidade || '')}</td>
      <td>${esc(i.descricao)}</td><td class="r">${brl(unit)}</td><td class="r">${brl(i.subtotal)}</td>
      <td class="c">${esc(i.ncm || '')}</td>
      ${mostrar_icms ? `<td class="r">${i.valor_icms != null ? brl(i.valor_icms) : ''}</td>` : ''}
    </tr>`;
  };
  const soma = arr => arr.reduce((s, i) => s + (parseFloat(i.subtotal) || 0), 0);
  const linhaSub = (rotulo, valor) => `<tr class="sub"><td colspan="5">${rotulo}</td><td class="r">${brl(valor)}</td><td colspan="${nCols - 6}"></td></tr>`;
  const totalItens = soma(itens);
  const desconto = parseFloat(pedido.desconto) || 0;
  const frete = parseFloat(pedido.frete) || 0;
  const total = Math.max(0, totalItens - desconto + frete);
  const corpoItens = [
    servicos.length ? servicos.map(linhaItem).join('') + linhaSub('Sub-Total Serviços', soma(servicos)) : '',
    pecas.length ? pecas.map(linhaItem).join('') + linhaSub(servicos.length ? 'Sub-Total Peças' : 'Sub-Total', soma(pecas)) : '',
    desconto > 0 ? linhaSub('Desconto', -desconto) : '',
    frete > 0 ? linhaSub('Frete', frete) : '',
    `<tr class="total"><td colspan="5">Total</td><td class="r">${brl(total)}</td><td colspan="${nCols - 6}"></td></tr>`,
  ].join('');

  // ── Condições comerciais ──
  const validadeDias = pedido.validade ? diasEntre(pedido.data_emissao, pedido.validade) : parseInt(cfg.validade_dias) || null;
  const garantia = pr.garantia_meses || cfg.garantia_meses;
  const pagamento = [pedido.forma_pagamento, pedido.condicao_pagamento].filter(Boolean).join(' – ');
  const local = pr.local_servico || cfg.local_servico;
  const impostos = pr.impostos || cfg.impostos;
  const condicoes = [
    pedido.prazo_entrega ? ['Prazo de Entrega', `${pedido.prazo_entrega} dia(s) úteis`] : null,
    pagamento ? ['Prazo de Pagamento', pagamento] : null,
    garantia ? ['Prazo de Garantia', `${garantia} mês(es)`] : null,
    validadeDias != null ? ['Validade', `${validadeDias} dia(s)${pedido.validade ? ` – até ${dataBR(pedido.validade)}` : ''}`] : null,
    pedido.tipo_frete ? ['Frete', FRETE_LABEL[pedido.tipo_frete] || pedido.tipo_frete] : null,
    impostos ? ['Impostos', impostos] : null,
    local ? ['Local de realização dos serviços', local] : null,
  ].filter(Boolean).map(([k, v]) => `<li><b>${esc(k)}:</b> ${esc(v)}</li>`).join('');

  // ── Cláusulas numeradas ──
  let nClausula = 0;
  const clausula = (titulo, texto) => {
    const li = linhasClausula(texto);
    if (!li) return '';
    nClausula += 1;
    return `<div class="clausula"><div class="cl-titulo">${nClausula} – ${titulo}</div><ul>${li}</ul></div>`;
  };

  const foneVendedor = [org.telefone ? `Tel: ${org.telefone}` : '', vendedor?.telefone ? `Cel: ${vendedor.telefone}` : '']
    .filter(Boolean).join('   ');

  return `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8">
<title>Proposta Comercial ${esc(numero)} – ${esc(nomeCliente)}</title>
<style>
  @page { size: A4; margin: 10mm 10mm 12mm; @bottom-right { content: counter(page) " de " counter(pages); font: 9pt Arial, sans-serif; color: #666; } }
  * { box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; font-size: 10.5pt; color: #1a1a1a; margin: 0; }
  @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
  table.pagina { width: 100%; border-collapse: collapse; }
  table.pagina > thead td, table.pagina > tfoot td { padding: 0; }
  .banner { width: 100%; display: block; }
  .cab-padrao { display: flex; align-items: center; gap: 16px; border-bottom: 3px solid #1e3a5f; padding-bottom: 8px; }
  .logo { max-height: 70px; max-width: 200px; object-fit: contain; }
  .cab-empresa { font-size: 9pt; color: #444; line-height: 1.4; }
  .cab-nome { font-size: 13pt; font-weight: bold; color: #1e3a5f; }
  .rod-padrao { border-top: 2px solid #1e3a5f; margin-top: 10px; padding-top: 5px; font-size: 8.5pt; color: #444; line-height: 1.5; }
  .titulo { display: flex; justify-content: space-between; align-items: baseline; margin: 12px 0 10px; font-weight: bold; }
  .titulo .num { font-size: 13pt; color: #1e3a5f; }
  .dest { line-height: 1.5; margin-bottom: 10px; }
  .dest .nome { font-size: 12pt; font-weight: bold; }
  .equip-titulo { font-size: 11.5pt; margin: 10px 0 4px; }
  table.grade { width: 100%; border-collapse: collapse; margin-bottom: 6px; }
  table.grade th, table.grade td { border: 1px solid #9aa5b8; padding: 3px 5px; font-size: 9pt; }
  table.grade th { background: #dfe5ee; font-weight: bold; text-align: center; }
  table.equip td { text-align: center; }
  table.nfent { width: auto; }
  table.itens tr { page-break-inside: avoid; }
  table.itens .sub td { background: #eef1f6; font-weight: bold; }
  table.itens .total td { background: #1e3a5f; color: #fff; font-weight: bold; font-size: 10.5pt; }
  .c { text-align: center; } .r { text-align: right; white-space: nowrap; }
  .extenso { font-size: 9pt; font-style: italic; margin: 2px 0 10px; }
  h3 { font-size: 10.5pt; margin: 14px 0 4px; color: #1e3a5f; border-bottom: 1px solid #c8d0dc; padding-bottom: 2px; }
  ul { margin: 2px 0 6px; padding-left: 20px; } li { margin: 1px 0; }
  .clausula { page-break-inside: avoid; margin-top: 8px; } .cl-titulo { font-weight: bold; }
  .obs { white-space: pre-wrap; border: 1px solid #c8d0dc; border-radius: 4px; padding: 6px 8px; margin-top: 6px; }
  .assinaturas { display: flex; justify-content: space-between; gap: 30px; margin-top: 26px; page-break-inside: avoid; }
  .assinaturas > div { flex: 1; line-height: 1.5; }
  .linha-ass { border-top: 1px solid #333; margin-top: 46px; padding-top: 3px; }
  .obs-final { font-weight: bold; margin-top: 14px; font-size: 9.5pt; page-break-inside: avoid; }
</style></head><body>
<table class="pagina">
  <thead><tr><td>${cabecalho}</td></tr></thead>
  <tfoot><tr><td>${rodape}</td></tr></tfoot>
  <tbody><tr><td>
    <div class="titulo">
      <span>${esc(org.cidade ? `${org.cidade.toUpperCase()}, ` : '')}${esc(dataExtenso(pedido.data_emissao))}</span>
      <span class="num">Proposta Comercial: ${esc(numero)}</span>
    </div>

    <div class="dest">
      À<br><span class="nome">${esc(nomeCliente)}</span><br>
      ${cliente?.cpf_cnpj ? `CPF/CNPJ: ${esc(fmtCnpjCpf(cliente.cpf_cnpj))}<br>` : ''}
      ${endCliente ? `${esc(endCliente)}<br>` : ''}
      ATT: ${esc(pr.aos_cuidados || '–')}<br>
      Fone: ${esc(fones || '–')}<br>
      E-mail: ${esc(cliente?.email || '–')}
    </div>

    <div>Prezado(a),<br>${esc(cfg.texto_introducao)}</div>

    ${blocoEquip}

    <table class="grade itens" style="margin-top:8px;">
      <thead><tr>
        <th style="width:6%">Item</th><th style="width:9%">Qtde</th><th style="width:5%">Un</th><th>Descrição</th>
        <th style="width:11%">Vlr. Unit.</th><th style="width:12%">Vlr. Total</th><th style="width:10%">NCM</th>
        ${mostrar_icms ? '<th style="width:9%">ICMS</th>' : ''}
      </tr></thead>
      <tbody>${corpoItens}</tbody>
    </table>
    <div class="extenso">Valor total: ${esc(valorPorExtenso(total))}.</div>

    ${condicoes ? `<h3>Condições Comerciais</h3><ul>${condicoes}</ul>` : ''}
    ${pr.identificacao ? `<div style="margin-top:6px;">${esc(pr.identificacao)}</div>` : ''}
    ${pedido.observacoes ? `<div class="obs"><b>Observações:</b> ${esc(pedido.observacoes)}</div>` : ''}

    ${clausula('Responsabilidades do Cliente', cfg.texto_responsabilidades)}
    ${clausula('Garantia', cfg.texto_garantia)}

    <p style="margin-top:14px;">Sendo só o que tínhamos para o presente momento, colocamo-nos à disposição para quaisquer esclarecimentos que porventura sejam desejados.</p>

    <div class="assinaturas">
      <div>
        Atenciosamente,<br>
        <b>${esc(vendedor?.nome || pedido.vendedor_nome || '')}</b><br>
        ${esc(nomeEmpresa)}<br>
        ${foneVendedor ? `${esc(foneVendedor)}<br>` : ''}
        ${vendedor?.email ? `E-mail: ${esc(vendedor.email)}` : (org.email ? `E-mail: ${esc(org.email)}` : '')}
      </div>
      <div>
        <div class="linha-ass">De acordo: ${esc(nomeCliente)}</div>
        <div style="margin-top:8px;">Data: ____/____/________</div>
      </div>
    </div>

    ${linhasClausula(cfg.texto_obs_final) ? `<div class="obs-final">Obs.: ${String(cfg.texto_obs_final).split('\n').map(l => esc(l.trim())).filter(Boolean).join('<br>')}</div>` : ''}
  </td></tr></tbody>
</table>
</body></html>`;
}

// `win` precisa ser aberta no próprio clique (antes de qualquer await),
// senão o navegador bloqueia o pop-up.
export async function imprimirPropostaComercial(dados, win) {
  const cfg = dados.org.proposta_config || {};
  const [logo, cabecalho, rodape] = await Promise.all([
    cfg.imagem_cabecalho_url ? Promise.resolve('') : fetchLogoBase64(dados.org.logo_url),
    fetchLogoBase64(cfg.imagem_cabecalho_url),
    fetchLogoBase64(cfg.imagem_rodape_url),
  ]);
  win.document.open();
  win.document.write(montarHtmlProposta(dados, { logo, cabecalho, rodape }));
  win.document.close();
  fecharComEsc(win);
  await aguardarImagens(win);
  win.focus();
  win.print();
}
